import React from "react";
import ReactPlayer from 'react-player'
import {Storage} from "aws-amplify"
import LinearProgress from '@mui/material/LinearProgress';
import {putMediaRenew} from "./ApiFunctions";

function StreamPlayer(props) {
    const playerReference = React.useRef()
    const [signedUrlReference, setSignedUrlReference] = React.useState(null)
    const [loaded, setLoaded] = React.useState(0)
    const [played, setPlayed] = React.useState(0)

    React.useEffect(()=> {
        async function getAWSUrl() {
            if (props.streamPlayerData.progress_create_hls === 100) {
                let certificateAge = (Date.now() - (new Date(props.streamPlayerData.updatedAt)).getTime())/1000
                console.log('Certificate age [s]: ', certificateAge)
                if (certificateAge > 18000){ //18000
                    console.log('Renew certificate')
                    await putMediaRenew(props.streamPlayerData.id)
                    console.log('Certificate renewed')
                }
                const fileAccessURLReference = await Storage.get(
                    props.streamPlayerData.id + props.m3u8File,
                    {
                        level: 'protected',
                        identityId: props.streamPlayerData.user_identity_id,
                        expires: 86400 });
                setSignedUrlReference(fileAccessURLReference);
            }
        }
        getAWSUrl()
    }, [props.streamPlayerData.id, props.streamPlayerData.progress_create_hls, props.m3u8File, props.streamPlayerData.user_identity_id, props.streamPlayerData.updatedAt])

    const handleOnProgress = async (e) => {
        setLoaded(e.loaded)
        setPlayed(e.played)
    }

    return (
        <>
            <div className='player-wrapper'>
                <ReactPlayer
                    width='100%'
                    height='100%'
                    url={signedUrlReference}
                    className="react-player"
                    ref={playerReference}
                    pip={false}
                    playing={false}
                    controls={true}
                    light={false}
                    loop={false}
                    playbackRate={1.0}
                    onStart={() => console.log('onStart')}
                    onProgress={handleOnProgress}
                    onPlay={() => {}}
                    onEnablePIP={() => {}}
                    onDisablePIP={() => console.log('handleDisablePIP')}
                    onPause={() => console.log('handlePause')}
                    onBuffer={() => console.log('onBuffer')}
                    onSeek={e => console.log('onSeek', e)}
                    onEnded={() => {}}
                    onError={e => console.log('onError', e)}
                    onDuration={() => {}}
                />
            </div>
            <div>
                <br/>
                <LinearProgress variant="buffer" value={100*played} valueBuffer={100*loaded} />
            </div>
            <br/>
        </>
    )
}

export default StreamPlayer;
